import React from "react";
import { RotatingLines } from "react-loader-spinner";

const Spinner = (props) => {
  const spinnerStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  };

  return (
    <div style={spinnerStyles}>
      <RotatingLines
        strokeColor="#3F5FDF"
        strokeWidth="5"
        animationDuration="0.75"
        width="24"
        visible={true}
        {...props}
      />
    </div>
  );
};

export default Spinner;
